import React from 'react';
import { NavLink } from 'react-router-dom';
import { Persona } from '../data/personas';
import SearchBar from './SearchBar';
import { isVoiceSupported } from './VoiceAssistant';
import './Header.css';

interface Props {
  personas: Persona[];
  activeId: string;
  onSelect: (userId: string) => void;
  onOpenVoice: () => void;
}

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  'header__data-btn' + (isActive ? ' header__data-btn--active' : '');

const homeNavLinkClass = ({ isActive }: { isActive: boolean }) =>
  'header__nav-item' + (isActive ? ' header__nav-item--active' : '');

export default function Header({ personas, activeId, onSelect, onOpenVoice }: Props) {
  const active = personas.find((p) => p.user.user_id === activeId) ?? personas[0];

  return (
    <header className="header">
      <div className="header__brand">
        <span className="header__logo">Watch</span>
        <nav className="header__nav">
          <NavLink to="/" end className={homeNavLinkClass}>
            Home
          </NavLink>
        </nav>
      </div>

      <div className="header__search-group">
        <SearchBar />
        <button
          className="header__voice-btn"
          onClick={onOpenVoice}
          disabled={!isVoiceSupported}
          title={isVoiceSupported ? 'Ask what to watch' : 'Voice not supported in this browser'}
        >
          W
        </button>
      </div>

      <div className="header__profile">
        <NavLink to="/data" className={navLinkClass}>
          Data
        </NavLink>
        <span className={`tier-pill tier-pill--${active.user.access_tier.toLowerCase()}`}>
          {active.user.access_tier}
        </span>
        <div className="header__persona">
          <span className="header__persona-name">{active.archetype}</span>
          <span className="header__persona-blurb">{active.blurb}</span>
        </div>
        <label className="header__switcher">
          <span className="header__switcher-label">Viewing as</span>
          <select
            value={activeId}
            onChange={(e) => onSelect(e.target.value)}
            aria-label="Switch viewer profile"
          >
            {personas.map((p) => (
              <option key={p.user.user_id} value={p.user.user_id}>
                {p.archetype}
              </option>
            ))}
          </select>
        </label>
      </div>
    </header>
  );
}
